<template>
  <div>

        <el-card shadow="never">
          Filter by Course Type
          <br>
          <el-form label-position="top"  size="small" >  

            <el-select
            size="mini"
            class="form-group border-input"
            placeholder="Select Days"
            v-model="days"
            @change="getClassroomsByDays"
          >
          
            <el-option
              v-for="day in daysArray"
              class="select-default"
              :value="day.value"
              :label="day.label"
              :key="day.value"
            ></el-option>
          </el-select>
         
          
          </el-form>
        </el-card>

   
  </div>
</template>

<script>
import gql from "graphql-tag";
import _ from 'lodash';
import json from "../../data/countries.json";
import { commonApi } from "../../api/common.js";
import { QUERY_STORED  } from '../../store/modules/queries'
import moment from "moment";
export default {
  name: "classroom-management",
  data() {
    return {
      countries: json,
      towns: {},
      classrooms: [],
      daysArray: [
        {
          value: 2,
          label: 'Weekend Classrooms (20 hour)'
        },
        {
          value: 3,
          label: 'Weekday Classrooms (30 hour)'
        },
        {
          value: 4,
          label: 'Weekend Virtual (20 hour)'
        },
        {
          value: 6,
          label: 'Weekday Virtual (30 hour)'
        },
        {
          value: 5,
          label: 'OTP Virtual'
        }
      ],
      total: 0
    };
  },
  methods: {

    getClassroomsByDaysOld(days) {
      this.$emit("loading", true);
      const daysPromise = commonApi.getClassroomsByDays(days);
      this.$store.dispatch(QUERY_STORED, { 
        days:this.days,
      })
      Promise.resolve(daysPromise).then(result => {
        this.classrooms = result.data;
        this.total = result.data.length
        this.$emit("total", this.total);
        this.$emit("loading", false);
        this.$emit("update:classrooms", this.classrooms);
        console.log("days",this.days);
        this.$emit("days",this.days);
      });
    },

    getClassroomsByDays(days) {
        var dateNow = moment().format();
        this.$emit("loading", true);
        this.$store.dispatch(QUERY_STORED, { 
          days:days,
        })
        this.$apollo
          .query({
            query: gql`
              {
                ClassRoom(
                  limit:10,
                  where: { 
                    _and: { 
                      
                      length: {
                        _eq: "${days}"
                      } 
                    }
                  },
                  order_by: {startDate: asc}
                ) {
                  id
                  additionalCost
                  allRatingsPercentage
                  code
                  courseRatingPercentage
                  dateCreated
                  dateUpdated
                  endDate
                  startTime
                  endTime
                  isOnline
                  historic
                  isPublic
                  length
                  sessions
                  meetingUrl
                  meetingID
                  maxAttendees
                  numAttendees
                  numberOfTens
                  tutorId
                  startDate
                  venueId
                  notes
                  canExchange
                  venue {
                    id
                    name
                    town
                  }
                  attendees {
                    customer {
                      id
                      firstname
                      lastname
                    }
                  }
                  tutor {
                    email
                    emailVerified
                    firstname
                    id
                    isActive
                    lastname
                    rating
                    username
                  }
                }
              

            }`,
            error(error) {
              this.error = JSON.stringify(error);
            }
        })
        .then(result => {
          this.classrooms = result.data.ClassRoom;
          this.total = this.classrooms.length;
          this.$emit("total", this.total);
          this.$emit("loading", false);
          this.$emit("update:classrooms", this.classrooms);
          console.log("days",days);
          this.$emit("days",days);
        })
      }

  },
 
    computed:{
      days:{get(){return this.$store.getters.getQueries.days},set(value){ this.$store.commit('updatedays', value)}}
    },

};
</script>

<style scoped>
  .min > *{
    padding:0 !important;margin:0 !important;
  }
  label{
    display: inline-block;
    padding:0 !important;margin:0 !important;
    font-weight:100 !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/UIComponents/ClassroomManagement.vue